import React from 'react';
import c from 'classnames';
import { useTranslation } from 'react-i18next';
import { useClearRefinements, useSearchBox } from 'react-instantsearch-core';
import { Button as RKSButton } from '@uncinc/uncinc-react-kitchen-sink';
import { DEFAULT_TEXT } from '../../config/constants';
const SearchReset = props => {
  const {
    t
  } = useTranslation();
  const {
    refine: clearRefinements
  } = useClearRefinements();
  const {
    clear: clearSearch
  } = useSearchBox();
  const {
    button,
    onClick,
    className,
    buttonText = t(['searchkit.buttons.reset', DEFAULT_TEXT.BUTTONS.RESET]),
    resetRefinements = true,
    resetSearch = true
  } = props;
  const classNames = c('Searchkit__Reset', className);
  const Button = button || RKSButton;
  return /*#__PURE__*/React.createElement(Button, {
    className: classNames,
    onClick: () => {
      if (resetRefinements) {
        clearRefinements();
      }
      if (resetSearch) {
        clearSearch();
      }
      if (onClick) {
        onClick();
      }
    }
  }, buttonText);
};
export default SearchReset;